import { Component, HostListener, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from './api.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
     selector: 'app-root',
     templateUrl: './app.component.html',
     styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnDestroy {
     title = 'GVA-UI-NEW';
     currentYear = (new Date()).getFullYear();
     url:string = '';
     version: string = '';
     private readonly destroySubject = new Subject();
     constructor(
          private router: Router, 
          public progress: ApiService, 
          private snackBar: MatSnackBar
     ) {}

     @HostListener('window:beforeunload', [ '$event' ])
     beforeUnloadHandler(event) {
          this.progress.multiFileUploadNames$
          .pipe(takeUntil(this.destroySubject))
          .subscribe((res: any) => {
               if(res?.length) {
                    const payLoad: string = res.toString();
                    this.progress.uploadCleanUp(payLoad)
                    .pipe(takeUntil(this.destroySubject))
                    .subscribe((res: any) => {
                         
                    },
                    (err) => {
                         
                    });
                    for (let i=0; i< res.length; i++) {
                         this.progress.removeMultiFileNames(res);
                    }
               }
          },
          (err) => {
               
          });
     }

     ngOnInit(): void {
          this.router.events.subscribe((event) => {
               this.url = this.router.url;
          });
          const sess_id = JSON.parse(localStorage.getItem('user'))?.token;
          if(!sess_id || sess_id == '') {
               if(this.url && this.url != '' && this.url != '/' && this.url != '/about' && this.url != '/about?id=contact' && !this.url.includes('reset') && !this.url.includes('activate') && this.url != '/privacypolicy' && this.url != '/terms-of-use') {
                    this.router.navigateByUrl('/');
               }
          }
          this.progress.version$.subscribe((value) => {
               this.version = value;
           })
           this.progress.orgID$.pipe(takeUntil(this.destroySubject)).subscribe((data) => {
               if(data) {
                    this.router.navigate(['/cases'], { queryParams: { page: 'allcases' } })
                    .then(() => {
                         window.location.reload();
                    });
               }
          });
     }

     ngOnDestroy(): void {}
}
